import { useContext } from 'react';
import { FeatureFlag, FeatureFlagVariant } from '../types';
import { FeatureFlagContext } from '../components/FeatureFlagProvider';
import { getFlags } from '../utils';
import { isEmpty } from '~/App/shared/utils';

export const useFeatureFlagValue = (
  flag: FeatureFlag,
  variant?: FeatureFlagVariant
): boolean => {
  const { flags } = useContext(FeatureFlagContext);
  const data = isEmpty(flags) ? getFlags() : flags;
  const userFlag = data?.[flag]?.value;

  // When we don't have a value
  if (!userFlag && typeof userFlag !== 'boolean') {
    return false;
  }

  // When we have a boolean value with no variant
  if (typeof userFlag === 'boolean' && typeof variant === 'undefined') {
    return userFlag;
  }

  // When we have a variant
  return userFlag === variant;
};
